export default class PRR {
    constructor(adapter) {
        this.client = adapter.getPlatformClient()

        this.PublicApp = "public-app"
        this.PlatformApp = "platform-app"
        this.Component = "component"
    }
    
    ref(q) {
        this._ref = q
        return this
    }
    
    format(f) {
        this._format = f
        return this
    }
    
    async resolve(resourceName) {
        const { data } = await this.client.post("/v3/system/resource-resolver", {
            type: resourceName,
            ref: this._ref,
            format: this._format
        })

        if (this._format) {
            return data.format 
        }
        
        return data
    }
}